import { createSession } from '@evnttz/session'

import { clientEnv } from '@/env.client'

/**
 * A instância única de sessão do gamification.
 *
 * Substitui o BFF Auth.js: o `client_secret` dos providers passa a morar só na
 * api, o access token vive em memória deste módulo e o refresh vive num cookie
 * HttpOnly que o JS nunca lê.
 *
 * É criada no import, e não sob demanda, porque o `tokenStore` e o portão de
 * boot precisam ser os mesmos para toda a aplicação — duas instâncias
 * significam dois tokens, duas renovações concorrentes e um logout que não
 * desloga.
 */
export const session = createSession({
  baseURL: clientEnv.NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL
})

/** Portão de boot: nenhuma requisição autenticada sai antes disto resolver. */
export const sessionReady = () => session.ready()

/**
 * O access token, para quem não passa por uma requisição HTTP comum.
 *
 * Casos legítimos: o ActionCable, porque WebSocket não passa por `fetch`, e a
 * ponte com o app nativo na WebView.
 */
export const getAccessToken = (): string | null => session.tokenStore.get()
